import { render } from "./DocumentList.vue?vue&type=template&id=7a17c019&scoped=true"
import script from "./DocumentList.vue?vue&type=script&lang=js"
export * from "./DocumentList.vue?vue&type=script&lang=js"

import "./DocumentList.vue?vue&type=style&index=0&id=7a17c019&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a17c019"]])

export default __exports__